/**
 * Entity Data Processing Utilities
 *
 * Centralized utilities for processing entity data before sending to the API.
 * This includes resolving user IDs, filtering relation data, and handling
 * field-specific conversions.
 *
 * This module is intentionally split into sibling files under
 * `./task-data-processing/`. Public surface preserved via re-exports.
 */

export {
  filterRelationData,
  resolveUserIds,
  processTagsField,
  processEntityDataFromApi,
} from "./task-data-processing/helpers";

export {
  processEntityDataForApi,
  processTaskDataForApi,
} from "./task-data-processing/for-api";

export {
  createProcessedMutationHandler,
  validateProcessedTaskData,
} from "./task-data-processing/convenience";
